import axios from 'axios'

export default {

    async archiveConversation({ conversation_id }) {
        return await axios.put(`/messages/conversation/archive/${conversation_id}`, {})
    },

    async createNewConversation({ title, groups, members }) {
        return await axios.post('/messages/conversations', {
            title : title,
            groups : groups,
            members : members
        })
    },

    async updateConversation({ id, title, groups, members, talk_room_id }) {
        const data = {
            title : title,
            groups : groups,
            members: members,
        }
        if(talk_room_id) data.talk_room_id = talk_room_id
        return await axios.put(`/messages/conversations/${id}`, data)
    },

    async getConversationMessages({ conversation_id }) {
        return await axios.get(`/messages/${conversation_id}`)
    },

    async getConversations() {
        return await axios.get('/messages/conversations')
    },

    async markConversationRead({ conversation_id }) {
        return await axios.put(`/messages/seen/${conversation_id}`, {})
    },

    async markConversationUnread({ conversation_id }) {
        return await axios.put(`/messages/unseen/${conversation_id}`, {})
    },

    async sendNewMessage({ conversation_id , message_data }) {
        return await axios.post('/messages', {
            conversation_id : conversation_id,
            message_data : message_data
        })
    },

    /**
     * @desc Update message
     *
     * message_data = {
     *    message_text: String,
     *    attachments: ArrayOf(Object),
     * }
    */
    async updateMessage({ conversation_id, message_id, message_data }) {
      // TODO: Returns updated message object
      return await axios.put(`/messages/${message_id}`, {
          conversation_id : conversation_id,
          message_data : message_data,
      })
    },

    async addConversationMembers({ conversation_id, members_data }) {
        return await axios.post(`/messages/conversations/${conversation_id}/members`, members_data)
    },

    async removeConversationMember({conversation_id, user_id}){
        return await axios.delete(`/messages/conversations/${conversation_id}/member/${user_id}`)
    },

    async removeMessage({conversation_id, message_id}) {
        return await axios.delete(`/messages/conversations/${conversation_id}/message/${message_id}`)
    },

    /**
     * @desc Soft-delete several messages in one conversation.
     *
     * Returns { deleted: [id], failed: [id], messages: [message] } — ids the
     * server could not delete come back in `failed` instead of failing the
     * whole call.
     */
    async removeMessages({conversation_id, message_ids}) {
        return await axios.delete(`/messages/conversations/${conversation_id}/messages`, {
            data : { message_ids : message_ids }
        })
    },

    /**
     * @desc Archive conversations for the current user only.
     *
     * The student-facing bulk action: hides the thread until the next message
     * un-archives it. Returns { archived, failed }.
     */
    async archiveConversations({conversation_ids}) {
        return await axios.put('/messages/conversations/archive', {
            conversation_ids : conversation_ids
        })
    },

    /**
     * @desc Soft-delete conversations for the current user only.
     *
     * The other participants keep the thread. Returns { deleted, failed }.
     */
    async removeConversations({conversation_ids}) {
        return await axios.delete('/messages/conversations', {
            data : { conversation_ids : conversation_ids }
        })
    },
    async getConversationAttachments({ conversation_id }) {
        return await axios.get(`/messages/${conversation_id}/attachments`)
    }
}
